
import { useStore } from "@/store";
import { computed, defineComponent } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";
import { VIRTUAL_SLOT_ID } from '@/models/Constants';

export default defineComponent({
  props: {
    selected: {
      type: Number,
    },
    productId: {
      type: Number
    }
  },
  async setup(props) {
    const router = useRouter();
    const store = useStore();
    const product = computed(() => store.state.selectedProduct);
    const canSellToPrivate: boolean = store.getters.canSellToPrivate;
    const currentLanguageId = computed(() => store.state.currentLanguageId);
    const showSlotWarning = computed(() => !product.value?.slotId);
    function onSelectDate() {
      if (!product.value?.slotId) {
        router.replace({
          name: "calendar",
          params: {
            productId: props.productId,
          },
        });
        return;
      }
      const slotId = product.value.slotId == VIRTUAL_SLOT_ID ? product.value.slotFakeId : product.value.slotId;
      router.push({
        name: "calendar",
        params: {
          productId: product.value?.productId,
          slotId: slotId,
          date: moment(product.value?.date).format("YYYY-MM-DD"),
        },
      });
    }
    function onSelectTime() {
      if (!product.value?.slotId) {
        router.replace({
          name: "calendar",
          params: {
            productId: props.productId,
            view: "day",
          },
        });
        return;
      }
      const slotId = product.value.slotId == VIRTUAL_SLOT_ID ? product.value.slotFakeId : product.value.slotId;
      router.push({
        name: "calendar",
        params: {
          productId: product.value?.productId,
          slotId: slotId,
          date: moment(product.value?.date).format("YYYY-MM-DD"),
          view: "day",
        },
      });
    }

    const displayTime = computed(() => {
      if (product.value?.slotId) {
        return moment(product.value.slotStartTime, "HH:mm:ss").format("HH:mm");
      }
      return "";
    });

    const date = computed(() => {
      if (product.value) {
        return moment(product.value.date).format("DD/MM/YYYY");
      }
      return "";
    });

    function ChangeOrderClientType() {
      router.push({
        name: "clientType",
        params: { productId: product.value?.productId },
      });
    }

    function ChangeOrderType() {
      router.push({ name: "orderType" });
    }

    const clientExist = computed(() => store.getters.orderBusinessClientExist);
    const priceType = computed(() =>
      store.state.priceTypes.find((x) => store.state.order.priceType == x.id)
    );

    const showOrderClientTypeWarning = computed(() => {
      if (!canSellToPrivate && !clientExist.value) {
        return true;
      }
      return false;
    });

    return {
      onSelectDate,
      onSelectTime,
      priceType,
      displayTime,
      ChangeOrderClientType,
      ChangeOrderType,
      clientExist,
      date,
      showOrderClientTypeWarning,
      currentLanguageId,
      showSlotWarning
    };
  },
});
